import React from "react";
import { Construction } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const ComingSoonPage = ({ title, description, icon: Icon = Construction, isDark, textClass, labelClass, cardClass }) => (
  <Card className={cardClass}>
    <CardHeader className="pb-3">
      <CardTitle className={`text-lg font-semibold flex items-center gap-2 ${textClass}`}>
        {Icon && <Icon className="w-5 h-5 text-amber-500" />}
        {title}
        <Badge className={isDark ? "bg-amber-500/15 text-amber-300 border-amber-500/30" : "bg-amber-50 text-amber-700 border-amber-200"}>
          Yakında
        </Badge>
      </CardTitle>
    </CardHeader>
    <CardContent>
      <p className={`text-sm ${labelClass}`}>{description}</p>
    </CardContent>
  </Card>
);

export default ComingSoonPage;
